import Loader from "../../../components/loader";
import { useBalancerPoolsData } from "../../../context/balancerPoolData";
import {
  useFetchMarginOrders,
  useMatchedTrades,
  usePendingOrderData,
  useTradeDetails,
} from "../../../context/contractDataLoaderService";
import OrdersTable from "./orders_table";
import WalletConnect from "../../../components/common/walletConnect/index";
import { PoolType } from "../../poolDetail/balancer/types";

import { useEffect, useState } from "react";
import { useAccount, useClient, useConnectorClient } from "wagmi";
import {
  getProviderNetwork,
  getProvider,
  getWeb3,
} from "../../../utils/helpers/networks";
import { providers } from "ethers";
import { useGlobal } from "../../../context/globalContext";

function PendingOrders(props) {
  const {
    userRole,
    userAddress,
    connectedChainId,
    connectedProvider,
    connectedSigner,
    connectedWeb3,
  } = useGlobal();

  const address = userAddress;
  const account = userAddress;
  const chainId = connectedChainId;

  const provider = connectedProvider;

  const signer = connectedSigner;

  const web3 = connectedWeb3;
  const [allOrders, setAllOrders] = useState([]);
  const [generalLoading, setGeneralLoading] = useState(true);
  let { data: marginPoolsData, loading: marginLoading } = useBalancerPoolsData(
    PoolType.MarginIssue
  );
  let { marginOrders: marginOrdersData, loading: marginOrdersLoading } =
    useFetchMarginOrders(marginPoolsData);

  let { data: primaryTradeDetails, loading: tradeDetailsLoading } =
    useTradeDetails();
  let { data: secondaryPoolsData, loading: secondaryLoading } =
    useBalancerPoolsData(PoolType.SecondaryIssue);

  let { pendingOrdersData } = usePendingOrderData(secondaryPoolsData);

  let formattedData = primaryTradeDetails
    ? [...marginOrdersData, ...pendingOrdersData, ...primaryTradeDetails]
    : [...marginOrdersData, ...pendingOrdersData];

  return (
    <>
      {tradeDetailsLoading || marginOrdersLoading || secondaryLoading ? (
        <Loader />
      ) : null}
      <section className="d-flex flex-column align-items-start px-0 py-4">
        <div className="w-100">
          <h3 className="mb-3 d-flex">Orders</h3>
          <OrdersTable
            {...props}
            data={formattedData || []}
            account={account}
            provider={provider}
            web3={web3}
            chainId={chainId}
          />
        </div>
      </section>
      <WalletConnect loggedIn={props.loggedIn} />
    </>
  );
}

export default function Orders(props) {
  return <PendingOrders {...props} />;
}
